{
  "actions": {
    "cancel": "Cancelar",
    "save": "Salvar",
    "saving": "Salvando...",
    "update": "Atualizar",
    "create": "Criar"
  },
  "page": {
    "notFound": "Curso não encontrado",
    "editMode": "Modo de edição",
    "viewAsStudent": "Ver como aluno"
  },
  "sectionTypes": {
    "banner": "Banner",
    "module": "Módulos",
    "course": "Cursos",
    "emptySpace": "Espaçamento"
  },
  "sidebar": {
    "removeTitle": "Remover item",
    "removeDescription": "Remover \"{{title}}\" do menu deste curso?",
    "remove": "Remover",
    "edit": "Editar",
    "emptyHint": "Sem itens próprios: alunos veem o menu global. Adicione itens para um menu exclusivo deste curso.",
    "addItem": "Adicionar item"
  },
  "chrome": {
    "dragToReorder": "Arrastar para reordenar",
    "hideFromStudent": "Ocultar do aluno",
    "showToStudent": "Mostrar para o aluno",
    "editSection": "Editar seção",
    "removeSection": "Remover seção"
  },
  "canvas": {
    "addSection": "Adicionar seção",
    "removeDescription": "Esta seção será removida da página do curso.",
    "remove": "Remover",
    "emptyTitle": "Página sem seções",
    "emptyDescription": "Gere o layout padrão (banner + módulos do curso) e personalize, ou comece adicionando seções manualmente.",
    "generateDefault": "Gerar layout padrão"
  },
  "bannerModal": {
    "title": "Editar Banner",
    "description": "Escolha o tipo de banner e configure seu conteúdo.",
    "variant": "Tipo de banner",
    "variantHero": "Destaque do curso (capa + progresso + botões)",
    "variantCustom": "Personalizado (imagem + título + botão)",
    "heroHint": "Usa a capa, título e descrição do curso. Escolha o que exibir:",
    "showCategory": "Mostrar categoria",
    "showProgress": "Mostrar barra de progresso",
    "showStart": "Mostrar botão Começar/Continuar",
    "showTrail": "Mostrar botão Ver Trilha",
    "image": "Imagem",
    "titleLabel": "Título",
    "titlePlaceholder": "Título do banner",
    "subtitle": "Subtítulo",
    "subtitlePlaceholder": "Texto de apoio (opcional)",
    "ctaSection": "Botão (opcional)",
    "ctaLabel": "Texto do botão",
    "ctaLabelPlaceholder": "Saiba mais",
    "ctaUrl": "Link",
    "ctaNewTab": "Abrir em nova aba"
  },
  "emptySpaceModal": {
    "title": "Editar Espaçamento",
    "description": "Define a altura do espaço em branco entre seções.",
    "height": "Altura",
    "sizes": {
      "sm": "Pequeno",
      "md": "Médio",
      "lg": "Grande"
    }
  },
  "picker": {
    "sectionTitle": "Título da seção",
    "dragHint": "Arraste os cards na página para reordenar.",
    "add": "Adicionar",
    "noResults": "Nenhum resultado"
  },
  "moduleModal": {
    "title": "Editar Seção de Módulos",
    "description": "Selecione módulos de qualquer curso. A ordem é definida arrastando os cards na página.",
    "titlePlaceholder": "Módulos",
    "selected": "Módulos selecionados ({{count}})",
    "noneSelected": "Nenhum módulo selecionado ainda.",
    "addLabel": "Adicionar módulo",
    "searchPlaceholder": "Buscar módulos...",
    "lessonsCount_one": "{{count}} aula",
    "lessonsCount_zero": "{{count}} aulas",
    "lessonsCount_other": "{{count}} aulas",
    "coursesCount_one": "{{count}} curso",
    "coursesCount_zero": "{{count}} cursos",
    "coursesCount_other": "{{count}} cursos",
    "noneAvailable": "Nenhum módulo disponível"
  },
  "courseModal": {
    "title": "Editar Seção de Cursos",
    "description": "Selecione outros cursos para divulgar nesta seção. A ordem é definida arrastando os cards na página.",
    "titlePlaceholder": "Cursos relacionados",
    "selected": "Cursos selecionados ({{count}})",
    "noneSelected": "Nenhum curso selecionado ainda.",
    "addLabel": "Adicionar curso",
    "searchPlaceholder": "Buscar cursos...",
    "noneAvailable": "Nenhum curso disponível"
  },
  "menuItemModal": {
    "title": "Item do menu",
    "description": "Configure um item da barra lateral deste curso.",
    "text": "Texto *",
    "textPlaceholder": "Ex: Comunidade",
    "link": "Link",
    "linkPlaceholder": "/community ou https://...",
    "icon": "Ícone",
    "external": "Link externo",
    "newTab": "Abrir em nova aba"
  },
  "menuItemForm": {
    "titleRequired": "Título é obrigatório",
    "editTitle": "Editar Item de Menu",
    "newTitle": "Novo Item de Menu",
    "editDescription": "Atualize as informações do item",
    "newDescription": "Adicione um novo link ao menu do aluno",
    "titleLabel": "Título *",
    "titlePlaceholder": "Ex: Comunidade, Suporte, Blog...",
    "icon": "Ícone",
    "iconPlaceholder": "Selecione um ícone",
    "linkType": "Tipo de Link",
    "manualUrl": "URL Manual",
    "linkToCourse": "Vincular a Curso",
    "url": "URL",
    "urlExternalPlaceholder": "https://exemplo.com",
    "urlInternalPlaceholder": "/pagina",
    "selectCourse": "Selecionar Curso",
    "searchCourse": "Buscar curso...",
    "noCourses": "Nenhum curso encontrado",
    "external": "Link externo",
    "newTab": "Abrir em nova aba",
    "active": "Item ativo",
    "create": "Criar Item",
    "icons": {
      "globe": "Globe (Web)",
      "externalLink": "Link Externo",
      "chat": "Chat",
      "help": "Ajuda",
      "document": "Documento",
      "video": "Vídeo",
      "music": "Música",
      "image": "Imagem",
      "calendar": "Calendário",
      "email": "Email",
      "phone": "Telefone",
      "location": "Localização",
      "store": "Loja",
      "favorite": "Favorito",
      "featured": "Destaque",
      "quickAction": "Ação Rápida",
      "course": "Curso",
      "community": "Comunidade",
      "gift": "Presente",
      "announcement": "Anúncio"
    }
  },
  "bannerForm": {
    "imageRequired": "Imagem é obrigatória",
    "editTitle": "Editar Banner",
    "newTitle": "Novo Banner",
    "editDescription": "Atualize as informações do banner",
    "newDescription": "Adicione um novo banner à plataforma",
    "image": "Imagem do Banner *",
    "titleLabel": "Título (opcional)",
    "titlePlaceholder": "Ex: Promoção de Verão",
    "linkLabel": "Link de destino (opcional)",
    "linkPlaceholder": "Ex: /courses ou https://...",
    "position": "Posição",
    "positions": {
      "home": "Home (Dashboard)",
      "sidebar": "Sidebar (Lateral)",
      "header": "Header (Topo)"
    },
    "active": "Banner ativo",
    "create": "Criar Banner"
  },
  "sectionForm": {
    "titleMin": "Título deve ter no mínimo 3 caracteres",
    "updateSuccess": "Seção atualizada com sucesso",
    "createSuccess": "Seção criada com sucesso",
    "saveError": "Erro ao salvar seção",
    "editTitle": "Editar Seção",
    "newTitle": "Nova Seção",
    "description": "Configure os dados da seção",
    "titleLabel": "Título *",
    "titlePlaceholder": "Ex: FASE 01 - O Chamado da Força",
    "descriptionLabel": "Descrição",
    "descriptionPlaceholder": "Descrição da seção (opcional)",
    "backgroundColor": "Cor de Fundo",
    "backgroundColorHint": "Cor de fundo customizada para esta seção (opcional)",
    "visible": "Visível",
    "visibleHint": "Exibir esta seção para os alunos"
  },
  "sectionManagement": {
    "deleteTitle": "Excluir seção",
    "deleteDescription": "Excluir esta seção? Os produtos não serão deletados.",
    "delete": "Excluir",
    "deleteSuccess": "Seção excluída com sucesso",
    "deleteError": "Erro ao excluir seção",
    "hiddenSuccess": "Seção ocultada",
    "visibleSuccess": "Seção visível",
    "visibilityError": "Erro ao atualizar visibilidade",
    "title": "Seções de Cursos",
    "subtitle": "Organize os cursos em seções horizontais estilo Netflix/Xtreed",
    "newSection": "Nova Seção",
    "hidden": "Oculta",
    "productsCount_one": "{{count}} produto",
    "productsCount_zero": "{{count}} produtos",
    "productsCount_other": "{{count}} produtos",
    "hide": "Ocultar",
    "show": "Mostrar",
    "emptyTitle": "Nenhuma seção criada",
    "emptyDescription": "Crie seções para organizar os cursos (ex: FASE 01, FASE 02)",
    "createFirst": "Criar Primeira Seção"
  },
  "toasts": {
    "createMenuItemError": "Erro ao criar item de menu",
    "createSectionError": "Erro ao criar seção",
    "deleteMenuItemError": "Erro ao remover item de menu",
    "deleteSectionError": "Erro ao remover seção",
    "reorderMenuError": "Erro ao reordenar menu",
    "reorderSectionsError": "Erro ao reordenar seções",
    "updateMenuItemError": "Erro ao atualizar item de menu",
    "updateSectionError": "Erro ao atualizar seção"
  }
}
